import {Singleton} from './../tools/Singleton';
import { GameManager } from './GameManager';

export class ScaleManager extends Singleton{
    
    scalingMode:ScaleMode = ScaleMode.LETTERBOX_FIll;
    game:Phaser.Game|null = null;
    element:HTMLDivElement|null = null;
    baseWidth:number|null = null;
    baseHeight:number|null = null;
    currentWidth:number|null = null;
    currentHeight:number|null = null;

    //Ratios
    scaleX:number|null = null;
    scaleY:number|null = null;
    screenRatio:number|null = null;
    pixelRatio:number|null = null;
    ratio:number|null = null;

    private isLandscapeOrientation:boolean = true;
    rescale(){

        if(this.game && this.element){
            this.scaleToElement(this.game,this.element);
        }else{
            console.log(`Can't rescale, ScaleManager: ${this.game?"":"game=null"},${this.element?"":"element=null"}`)
        }
    }

    isOrientationLandscape():boolean{
        return this.isLandscapeOrientation;
    }

    scaleToElement(game:Phaser.Game,element:HTMLDivElement){

        this.game = game;
        this.element = element;

        //Get Dimensions based on Orientation
        if(element.clientWidth > (element.clientHeight > 0 ? element.clientHeight : window.innerHeight)){
            this.isLandscapeOrientation = true;
            this.currentWidth = this.baseWidth;
            this.currentHeight = this.baseHeight;
        }else{
            this.isLandscapeOrientation = false;
            this.currentWidth = this.baseHeight;
            this.currentHeight = this.baseWidth;
        }

        //Get XY Scale
        let scaleX=1;
        let scaleY=1;
        if(element) {
            scaleX = element.clientWidth / this.currentWidth!;
            scaleY =  element.clientHeight / this.currentHeight!;
            if(scaleX == 0 ){
                scaleX = window.innerWidth / this.currentWidth!;
            }
            if(scaleY == 0 ){
                scaleY = window.innerHeight / this.currentHeight!;
            }
        }
        else
        {
            scaleX = window.innerWidth / this.currentWidth!;
            scaleY = window.innerHeight / this.currentHeight!;
        }
        this.scaleX = scaleX;
        this.scaleY = scaleY;
        console.log(`ScaleX: ${scaleX} | ScaleY: ${scaleY}`);

        //Get Scale Ratio
        let screenRatio;
        if(this.scalingMode == ScaleMode.LETTERBOX || this.scalingMode == ScaleMode.LETTERBOX_FIll){
            screenRatio = scaleX < scaleY ? scaleX : scaleY;
        }
        console.log("Screen Scale Ratio:"+screenRatio);
        this.screenRatio = screenRatio;

        //Get Pixel Ratio
        let pixelRatio = this.computePixelRatio(game.canvas);
        console.log(`pixelRatio: ${pixelRatio}`);
        this.pixelRatio = pixelRatio;

        //Get Total Ratio
        let ratio = screenRatio * pixelRatio;
        this.ratio = ratio;

        //Canvas CSS
        game.canvas.style.paddingLeft = '0';
        game.canvas.style.paddingRight = '0';
        game.canvas.style.paddingTop = '0';
        game.canvas.style.paddingBottom = '0';
        game.canvas.style.display = "block";
        game.canvas.style.position = "absolute";

        //Get New Size from new element size
        let newWidth = this.currentWidth;
        let newHeight = this.currentHeight;
        if(this.scalingMode == ScaleMode.LETTERBOX){
            let currentWidth = window.innerWidth;
            let currentHeight = window.innerHeight;
            if(element){
                currentWidth = element.clientWidth;
                currentHeight = element.clientHeight;
            }
            newWidth = scaleX < scaleY ? currentWidth : scaleY * this.currentWidth!;
            newHeight = scaleX < scaleY ? scaleX* this.currentHeight! : currentHeight;
        }else if(this.scalingMode == ScaleMode.LETTERBOX_FIll){
            if(element){
                newWidth = element.clientWidth;
                newHeight = element.clientHeight > 0 ? element.clientHeight : window.innerHeight;
            }else{
                newWidth = window.innerWidth;
                newHeight = window.innerHeight;
            }
            
        }else if(this.scalingMode == ScaleMode.NONE){
            newWidth = this.currentWidth;
            newHeight = this.currentHeight;
        }
        console.log(`newWidth: ${newWidth} | newHeight: ${newHeight}`);

        //Compute
        let newHiPPIWidth = newWidth! * pixelRatio;
        let newHiPPIHeight = newHeight! * pixelRatio;
        (<any>game).resize(newHiPPIWidth,newHiPPIHeight);
        game.canvas.style.width = newWidth! + 'px';
        game.canvas.style.height = newHeight! + 'px';
        let ctx = game.context;
        if(ctx){
            ctx!.scale(pixelRatio,pixelRatio);
        }
        console.log(`newHiPPIWidth: ${newHiPPIWidth} | newHiPPIHeight: ${newHiPPIHeight}`);

        //Center Canvas
        this.centerCanvas(game.canvas,element);
        
        //Reposition Camera
        if(game.scene.scenes.length>0){
            for (let index = 0; index < game.scene.scenes.length; index++) {
                let currentScene = (<Phaser.Scene>game.scene.scenes[index]);
                let cam:Phaser.Cameras.Scene2D.Camera = currentScene.cameras.main;
                cam.setZoom(ratio);
                cam.setSize(newHiPPIWidth,newHiPPIHeight);
                console.log("Camera Zoom Set to:"+(ratio));
                cam.setPosition(0,0);
                cam.setScroll(0,0);
                cam.scrollX = (cam.width * -0.5) + (this.currentWidth!)/2;
                cam.scrollY = (cam.height * -0.5) + (this.currentHeight!)/2;
            }
        }
        //this.DrawCameraBounds(); //Debug
    }

    drawCameraBounds(game){
        if(game.scene.scenes.length>0){
            for (let index = 0; index < game.scene.scenes.length; index++) {
                let currentScene = (<Phaser.Scene>game.scene.scenes[index]);
                let cam:Phaser.Cameras.Scene2D.Camera = currentScene.cameras.main;
                var polygon = new Phaser.Geom.Polygon([
                            new Phaser.Geom.Point(cam.x,cam.y),
                            new Phaser.Geom.Point(cam.x+cam.width,cam.y),
                            new Phaser.Geom.Point(cam.x+cam.width,cam.y + cam.height),
                            new Phaser.Geom.Point(cam.x,cam.y + cam.height)
                        ]);
                let graphics;
                if(graphics==null){
                    graphics = currentScene.add.graphics({ x: 0, y: 0 });
                }
                graphics.clear();
                graphics.lineStyle(2, 0x00aa00);
                graphics.beginPath();
                graphics.moveTo(polygon.points[0].x, polygon.points[0].y);
                for (var i = 1; i < polygon.points.length; i++)
                {
                    graphics.lineTo(polygon.points[i].x, polygon.points[i].y);
                }
                graphics.closePath();
                graphics.strokePath();
            }
        }
    }

    computePixelRatio(canvas:HTMLCanvasElement){
        console.log(canvas);
        let ctx = canvas.getContext("2d");
        let dpr = window.devicePixelRatio || 1;
        let bsr = ctx == null ? 1 : (<any>ctx).webkitBackingStorePixelRatio ||
                (<any>ctx).mozBackingStorePixelRatio ||
                (<any>ctx).msBackingStorePixelRatio ||
                (<any>ctx).oBackingStorePixelRatio ||
                (<any>ctx).backingStorePixelRatio || 1;

        return dpr / bsr;
    }

    centerCanvas(canvas:HTMLCanvasElement,element:HTMLDivElement){
        canvas.style.marginTop = '0';
        canvas.style.marginTop = '0';
        canvas.style.marginBottom = '0';
        canvas.style.marginLeft = '0';
        canvas.style.marginRight = '0';
        
        let margin;
        if(element)
            margin = (element.clientWidth - parseInt(canvas.style.width!,10)) / 2;
        else
            margin = (window.innerWidth - parseInt(canvas.style.width!,10)) / 2;
        canvas.style.marginLeft = margin + "px";
        canvas.style.marginRight = margin + "px";

        if(element)
            margin = (element.clientWidth - parseInt(canvas.style.width!,10)) / 2;
        else
            margin = (window.innerWidth - parseInt(canvas.style.width!,10)) / 2;
        canvas.style.marginLeft = margin + "px";
        canvas.style.marginRight = margin + "px";
    }

    getRelativePosition(x:number,y:number,isLogical?:boolean):Phaser.Math.Vector2{
        let position;
        if(isLogical==null || isLogical == true){
            position = new Phaser.Math.Vector2(x * this.currentWidth!, y * this.currentHeight!);
        }else{
            let xC = (x * this.game!.canvas.width);
            let yC = (y * this.game!.canvas.height);
            let xBC = this.currentWidth! * this.ratio!;
            let yBC = this.currentHeight! * this.ratio!;
            let xM = (this.game!.canvas.width-(this.currentWidth! * this.ratio!))/2;
            let yM = (this.game!.canvas.height-(this.currentHeight! * this.ratio!))/2;
            let xF = xC - Math.max(xM,0);
            let yF = yC - Math.max(yM,0);
            let xD = xF / xBC;
            let yD = yF / yBC;
            position = new Phaser.Math.Vector2(xD * this.currentWidth!, yD * this.currentHeight!);
            // console.log(`Canvas Width: ${this.game!.canvas.width} Canvas Height: ${this.game!.canvas.height}`);
            // console.log(`
            //     X: ${x} Y: ${y} 
            //     Canvas Width: ${this.game!.canvas.width} Canvas Height: ${this.game!.canvas.height} 
            //     XC: ${xC} YC: ${yC} 
            //     XBC: ${xBC}  YBC: ${yBC} 
            //     XM: ${xM} YM: ${yM} 
            //     XF: ${xF} YF: ${yF}
            //     XD: ${xD} YD: ${yD}`);
        }
        
        return position;
    }

    getRatio()
    {
        return this.ratio;
    }
}

export enum ScaleMode{
    NONE,
    LETTERBOX,
    LETTERBOX_FIll,
    ZOOM_TO_BIGGER,
    ZOOM_NON_UNIFORM
}
